import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { filter } from 'rxjs/operators';
import { isUndefined, forEach } from 'lodash';

@Component({
  selector: 'eyrus-questionnaire-question-radio',
  templateUrl: './question-radio.component.html',
  styleUrls: ['./question-radio.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuestionRadioComponent), multi: true
    }
  ]
})
export class QuestionRadioComponent implements OnInit {

  @Input() options: Array<any> = [];
  @Input() label: String = 'text';
  @Input() value: String = 'answerId';
  @Input() readOnly: Boolean = false;

  questionControl: FormControl = new FormControl();

  private subscriptions: any = {};

  propagateChange: any = () => { };
  propageteTouch: any = () => { };
  validateFn: any = () => { };

  constructor() { }

  ngOnInit() {
    this.watchChanges();
  }

  ngOnDestroy() {
    forEach(this.subscriptions, (value) => value.unsubscribe());
  }

  //  functions to be used inside a reactive form
  writeValue(value) {
    this.questionControl.setValue(value);
  }

  //  functions to be used inside a reactive form
  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  //  functions to be used inside a reactive form
  registerOnTouched(fn) {
    this.propageteTouch = fn;
  }

  /**
   * Watch value changes for select
   */
  private watchChanges() {
    this.subscriptions.text = this.questionControl.valueChanges
      .pipe(
        filter(val => !isUndefined(val))
      )
      .subscribe(val => {
        this.propagateChange(val);
        this.propageteTouch(val);
      });
  }

}
